module.exports = __webpack_public_path__ + "static/jane_street-1fc4dc8784c4ad46a66e2d1346875208.png";